import React, { FC, SyntheticEvent, useCallback, useEffect, useState } from "react";
import { Box, Container, Tabs, Tab } from "@mui/material";
import Layout from "../../../common/layouts/Layout";
import Navbar from "../../../common/Navbar/Navbar";
import { a11yProps } from "../../../../utils/helper";
import TabPanel from "../../../common/TabPanel/TabPanel";
import CreateNewMeetingContainer from "./MeetingDetails";
import MeetingScheduleContainer from "./ScheduleDetails";
import { useFindOneMeetingLazyQuery, useFindOneMeetingQuery } from "../../../../generated/graphql";
import { useParams } from "react-router-dom";

const CreateAndUpdateMeetingContainer: FC = (props) => {
  const [ECSubmissionTabValue, setECSubmissionTabValue] = useState(0);
  const [visibleTabs, setVisibleTabs] = useState(2);
  const handleECSubmissionTabChange = (
    event: SyntheticEvent,
    newValue: any
  ) => {
    setECSubmissionTabValue(newValue);
  };

  const {id}= useParams() as { id: string};


  const [getMeeting, { loading }] = useFindOneMeetingLazyQuery();

  const fetchMeeting = useCallback(async (id: string) => {
    let res = await getMeeting({
      variables: {
        _id: id,
      },
    });

    let data = res.data?.findOneMeeting;
    console.log(data);
    if (!data?.mom) {
      console.log('True');
      setVisibleTabs(1);
    }else console.log('False');
  }, []);

  useEffect(() => {
    if (id) {
      fetchMeeting(id);
    }
  }, [id]);

  return (
    <>
      <Layout>
        <>
          <Navbar pageTitle="New EC Submission" />
          <Container maxWidth={false}>
            <div>
              <Box className={`custom-tabs`}>
                <Tabs
                  value={ECSubmissionTabValue}
                  onChange={handleECSubmissionTabChange}
                  aria-label="tabs"
                >
                  <Tab label="Meeting Details" {...a11yProps(0)} />
                  {visibleTabs ===2 && <Tab label="Schedule Details" {...a11yProps(1)} />}
                </Tabs>
                <TabPanel value={ECSubmissionTabValue} index={0}>
                  <CreateNewMeetingContainer/>
                </TabPanel>
                <TabPanel value={ECSubmissionTabValue} index={1}>
                  {/* <AdditionalDocument value={ECSubmissionTabValue} /> */}
                  <MeetingScheduleContainer/>
                </TabPanel>
              </Box>
            </div>
          </Container>
        </>
      </Layout>
    </>
  );
};

export default CreateAndUpdateMeetingContainer;
